import { Checkbox, Form, InputNumber, Spin, Typography } from 'antd'
import React, { FunctionComponent } from 'react'

import { OneLineHelp } from '../OneLineHelp/OneLineHelp'

export interface PropertyDetailPriceUnitFormProps {
  initialValues: PropertyDetailPriceUnitFormValues
  setFormValues: (_: unknown, values: PropertyDetailPriceUnitFormValues) => void
}

export interface PropertyDetailPriceUnitFormValues {
  unitAreaM2: number | null
  hasElevator: boolean
  isNewBuild: boolean
  isNonPanelOrBrick: boolean
  hasTerrace?: boolean
  hasBalcony?: boolean
  hasGarage?: boolean
  loading: boolean
}

export const PropertyDetailPriceUnitForm: FunctionComponent<PropertyDetailPriceUnitFormProps> =
  props => {
    return (
      <div>
        <Typography.Title level={4}>Parametry bytové jednotky</Typography.Title>
        <Form
          disabled={props.initialValues.loading}
          layout="vertical"
          initialValues={props.initialValues}
          onValuesChange={props.setFormValues}
        >
          <div className="flex flex-wrap items-start gap-x-12 gap-y-6">
            <Form.Item
              name="unitAreaM2"
              label="Výměra jednotky"
              className="!mb-0"
            >
              <InputNumber
                min={1}
                step={1}
                addonAfter={
                  props.initialValues.loading ? <Spin size="small" /> : 'm²'
                }
              />
            </Form.Item>

            <Form.Item label="Příslušenství a vlastnosti" className="!mb-0">
              <div className="flex flex-wrap items-center gap-4">
                <Form.Item name="hasElevator" valuePropName="checked" noStyle>
                  <Checkbox>Výtah</Checkbox>
                </Form.Item>
                <Form.Item name="hasTerrace" valuePropName="checked" noStyle>
                  <Checkbox>Terasa</Checkbox>
                </Form.Item>
                <Form.Item name="hasBalcony" valuePropName="checked" noStyle>
                  <Checkbox>Balkón</Checkbox>
                </Form.Item>
                <Form.Item name="hasGarage" valuePropName="checked" noStyle>
                  <Checkbox>Garáž</Checkbox>
                </Form.Item>
                <Form.Item name="isNewBuild" valuePropName="checked" noStyle>
                  <Checkbox>Novostavba</Checkbox>
                </Form.Item>
                <Form.Item
                  noStyle
                  shouldUpdate={(prev, cur) =>
                    prev.isNewBuild !== cur.isNewBuild
                  }
                >
                  {({ getFieldValue }) =>
                    getFieldValue('isNewBuild') ? (
                      <Form.Item
                        name="isNonPanelOrBrick"
                        valuePropName="checked"
                        noStyle
                      >
                        <Checkbox>Jiný materiál než panel a cihla</Checkbox>
                      </Form.Item>
                    ) : null
                  }
                </Form.Item>
              </div>
            </Form.Item>

            <Form.Item
              label={<span className="text-gray-400">Nápověda</span>}
              className="!mb-0 flex-1"
            >
              <OneLineHelp
                classNameClose="max-w-sm"
                className="transition-colors text-gray-400"
                classNameOpen="min-w-[24rem] whitespace-pre-wrap text-gray-800 pt-2"
              >
                Pokud jsou informace dostupné, doplní se údaje o výměře, výtahu,
                novostavbě (budova mladší 5 let) a materiálu konstrukce
                automaticky. {`\n`}Terasu, balkón a garáž je potřeba vybrat
                ručně. {`\n`}Cenové údaje v tabulkách jsou statistickým vzorkem
                realitního trhu a dat MFČR za uplynulých 12 měsíců. {`\n`}
                Hodnota
                {' "Pokrytost" '}udává počet odpovídajících nemovitostí
                použitých pro výpočet hodnoty za m². {`\n`}Výsledné hodnoty pro
                bytovou jednotku jsou počítány jako cena za m² × uvedená výměra
                jednotky.
                {`\n`}
              </OneLineHelp>
            </Form.Item>
          </div>
        </Form>
      </div>
    )
  }
